export class GeoContent {
    constructor() {
        this.regionContentContainer = document.querySelector('.content[data-region-content-map]');
        this.popupContainer = document.querySelector('.content[data-geo-popup-rules]');

        if (!this.regionContentContainer && !this.popupContainer) {
            return;
        }

        this.detectGeo();
    }

    async detectGeo() {
        const cached = this.getGeoCookie();
        if (cached) {
            this.applyForRegion(cached);
            return;
        }

        const geo = await this.fetchGeo();
        if (!geo) {
            document.documentElement.classList.remove('region-loading');
            return;
        }

        document.cookie = `_ad__RE=${JSON.stringify({...geo, ts: Date.now()})}; path=/; max-age=86400`;

        this.applyForRegion(geo);
    }

    // if the rule is just a country like "US" it means any state/region in that country counts.
    // if it has a dash like "CA-ON" it has to match that exact region.
    matchesRegion(ruleRegion, geo) {
        if (!ruleRegion.includes('-')) {
            return geo.cC === ruleRegion;
        }
        return `${geo.cC}-${geo.r}` === ruleRegion;
    }

    applyForRegion(geo) {
        const regionCode = `${geo.cC}-${geo.r}`;

        if (this.regionContentContainer) {
            let regionContentMap = {};
            try {
                regionContentMap = JSON.parse(this.regionContentContainer.dataset.regionContentMap);
            } catch {}

            if (regionContentMap[regionCode]) {
                this.swapContent(regionContentMap[regionCode], regionCode);
            } else {
                document.documentElement.classList.remove('region-loading');
            }
        }

        if (this.popupContainer) {
            let rules = [];
            try {
                rules = JSON.parse(this.popupContainer.dataset.geoPopupRules);
            } catch {}

            // find the first rule that matches where the person is, and show that popup.
            const rule = rules.find(rule => this.matchesRegion(rule.region, geo));
            if (rule) {
                this.showRegionPopup(rule);
            }
        }
    }

    getGeoCookie() {
        const raw = document.cookie.split('; ').find(row => row.startsWith('_ad__RE='));
        if (!raw) return null;
        try {
            const geo = JSON.parse(raw.split('=').slice(1).join('='));
            // old cookies dont have a ts so they just fail this and get treated as dead
            const isFresh = geo.ts && (Date.now() - geo.ts) < 86400000;
            if (isFresh && geo.cC && geo.r && geo.cC !== 'N/A' && geo.r !== 'N/A') {
                return geo;
            }
        } catch {}
        return null;
    }

    async fetchGeo() {
        try {
            const response = await fetch(`https://neo7x.com/v1/?domain=${window.location.hostname}`);
            if (!response.ok) return null;
            const data = await response.json();
            return data?.geoloc ?? null;
        } catch {
            return null;
        }
    }

    async swapContent(regionContent, regionCode) {
        const contentDiv = this.regionContentContainer;
        if (!contentDiv) return;

        const pageContent = contentDiv.querySelector('.page-content');
        if (!pageContent) return;

        try {
            const response = await fetch(regionContent.url);
            if (!response.ok) {
                document.documentElement.classList.remove('region-loading');
                return;
            }

            const json = await response.json();
            if (!json.data?.html) {
                document.documentElement.classList.remove('region-loading');
                return;
            }

            const fragment = document.createRange().createContextualFragment(json.data.html);
            pageContent.innerHTML = '';
            const notice = document.createElement('p');
            notice.className = 'region-geo-notice';
            notice.textContent = `You are viewing ${regionContent.label}-specific content and licensed online casinos based on your location.`;
            pageContent.appendChild(notice);
            pageContent.appendChild(fragment);
            window.bo.events.bindAll(pageContent);
            document.documentElement.classList.remove('region-loading');
            // let ToplistFirstItemFooter know region content is showing, so it skips the bonus footer
            document.documentElement.dataset.regionContent = regionCode;
            document.querySelector('.evt-toplist-first-item-footer')?.remove();
        } catch {
            document.documentElement.classList.remove('region-loading');
        }
    }

    // text and logo for each region's popup
    static REGION_POPUP_COPY = {
        'CA-ON': {
            logo: `<img src="/assets/img/svg/igaming-ontario-logo-gray.svg" width="100" height="15" alt="iGaming Ontario" class="geo-popup__logo">`,
            name: 'Ontario',
            licensedBy: 'iGaming Ontario',
        },
        'CA-AB': {
            logo: `<img src="/assets/img/svg/aglc-logo-footer-gray.svg" width="42" height="15" alt="AGLC" class="geo-popup__logo">`,
            name: 'Alberta',
            licensedBy: 'AGLC',
        },
    };

    showRegionPopup(rule) {
        const contentDiv = this.popupContainer;
        if (!contentDiv) return;

        const targetUrl = rule.url;
        const isBlock = !!rule.block;
        // "US" rule = whole USA is blocked, no matter the state. this one has no link
        // to click through to since we don't have a US-specific section like Ontario/Alberta do.
        const isUsBlock = rule.region === 'US';
        const copy = GeoContent.REGION_POPUP_COPY[rule.region] ?? { logo: '', name: rule.region, licensedBy: '' };

        const overlay = document.createElement('div');
        overlay.className = 'geo-popup-overlay' + (isBlock ? ' geo-popup-overlay--block' : '');

        const popup = document.createElement('div');
        popup.className = 'geo-popup';

        if (isUsBlock) {
            popup.innerHTML = `
                <h2 class="geo-popup__title">Not available in your region</h2>
                <p class="geo-popup__text">Sorry, this content isn't available in your region.</p>
            `;
        } else if (isBlock) {
            popup.innerHTML = `
                ${copy.logo}
                <h2 class="geo-popup__title">${copy.name} residents – please note</h2>
                <p class="geo-popup__text">This page shows content made for Rest of Canada players. We have a ${copy.name}-specific section featuring casinos licensed by ${copy.licensedBy}.</p>
                <div class="geo-popup__actions">
                    <a href="${targetUrl}" class="button orange geo-popup__cta">View ${copy.name}-licensed casinos</a>
                </div>
            `;
        } else {
            popup.innerHTML = `
                ${copy.logo}
                <h2 class="geo-popup__title">You appear to be in ${copy.name}</h2>
                <p class="geo-popup__text">This page is for Rest of Canada players and does not reflect ${copy.name}'s regulated market. As a ${copy.name} resident, you can only access ${copy.licensedBy}-licensed casinos.</p>
                <div class="geo-popup__actions">
                    <a href="${targetUrl}" class="button orange geo-popup__cta">Go to ${copy.name} casinos</a>
                    <button class="geo-popup__dismiss">Stay on this page</button>
                </div>
            `;

            popup.querySelector('.geo-popup__dismiss').addEventListener('click', () => {
                overlay.remove();
                document.documentElement.classList.remove('geo-popup-open');
            });
        }

        overlay.appendChild(popup);
        document.body.appendChild(overlay);
        document.documentElement.classList.add('geo-popup-open');
    }
}
